import styled from "styled-components";
import { Card } from "antd";

const Container = styled.div`
  padding: 20px;
  overflow-y: scroll;
`;

const BannerCard = styled(Card)`
  width: 25vw;
  height: 50vh;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 20px;
`;

export { Container, BannerCard };
